/* eslint-disable operator-linebreak */
/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import Loading from '../../../components/Loading';
import api from '../../../services/api';
import { convertForRealFormatted } from '../../../utils/convertForRealFormatted';
import { convertNumberPercent } from '../../../utils/convertNumberPercent';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import * as S from './styles';

function MetasComponent({
  provider,
  selectedAnchor,
  updateContent,
  isLoading,
  setIsLoading
 }) {
  const [metas, setMetas] = useState([]);

  const fetchMetas = async () => {
    setIsLoading(true);
    try {
      const date = new Date();
      const response = await api.get(
        `OperacoesAntecipacoes/ConsultarAncorasMetas?ancoraId=${selectedAnchor?.ancoraId}&mes=${
          date.getMonth() + 1
        }&ano=${date.getFullYear()}`,
      );
      if (response.data.status !== 'Inconsistencia') {
        setMetas(response.data.resposta);
      } else {
        handleErrorRequest(response);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setIsLoading(false);
  };

  function convertValue(labelValue) {
    return convertForRealFormatted(labelValue || 0, 0);
  }

  useEffect(() => {
    fetchMetas();
  }, [selectedAnchor, provider, updateContent]);

  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title text-center">Metas</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  return (
    <S.MetasBox>
      <S.TableTitleHeader>
        <h3 className="operation-title text-center">CAR - Capittale Ação p Resultados</h3>
        <Tooltip placement="top" title="Recarregar conteúdo">
          <CachedIcon className="pointer" onClick={() => fetchMetas()} />
        </Tooltip>
      </S.TableTitleHeader>
      <S.MetasContainer>
        <div className="metas-header">
          <p></p>
          <p className="text-left">Objetivo</p>
          <p className="text-left">Realizado</p>
          <p>%</p>
        </div>
        <div className="metas-body">
          <div className="metas-body-row">
            <p>Receita</p>
            <p>{convertValue(metas?.receitaObjetivo)}</p>
            <p>{convertValue(metas?.receitaRealizado)}</p>
            <p>{convertNumberPercent(metas?.percentualAtingidoReceita, 0)}</p>
          </div>
          <div className="metas-body-row">
            <p>Volume</p>
            <p>{convertValue(metas?.volumeObjetivo)}</p>
            <p>{convertValue(metas?.volumeRealizado)}</p>
            <p>{convertNumberPercent(metas?.percentualAtingidoVolume, 0)}</p>
          </div>
          <div className="metas-body-row">
            <p>Qualificados</p>
            <p>{metas?.quantidadeQualificadosObjetivo}</p>
            <p>{metas?.quantidadeQualificadosRealizado}</p>
            <p>{convertNumberPercent(metas?.percentualAtingidoQuantidadeQualificados, 0)}</p>
          </div>
          <div className="metas-body-row">
            <p>Não Qualificados</p>
            <p>{metas?.quantidadeNaoQualificadosObjetivo}</p>
            <p>{metas?.quantidadeNaoQualificadosRealizado}</p>
            <p>{convertNumberPercent(metas?.percentualAtingidoQuantidadeNaoQualificados, 0)}</p>
          </div>
          <div className="metas-body-row">
            <p>% Atingido</p>
            <p>{}</p>
            <p>{}</p>
            <p>{convertNumberPercent(metas?.percentualPonderadoTotal, 1)}</p>
          </div>        
          <div className="metas-body-row">
            <p>Operações</p>
            <p>{metas?.quantidadeOperacoesObjetivo}</p>
            <p>{metas?.quantidadeOperacoesRealizado}</p>
            <p>{convertNumberPercent(metas?.percentualAtingidoQuantidadeOperacoes, 0)}</p>
          </div>
          </div>
      </S.MetasContainer>
    </S.MetasBox>
  );
}

export default MetasComponent;
